import { render, staticRenderFns } from "./TwoColumnsCenter.vue?vue&type=template&id=7a881a2e&scoped=true&"
import script from "./TwoColumnsCenter.vue?vue&type=script&lang=js&"
export * from "./TwoColumnsCenter.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumnsCenter.vue?vue&type=style&index=0&id=7a881a2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a881a2e",
  null
  
)

export default component.exports